import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var pollListRes;
export const pollListTodo = createAsyncThunk('pollList', async () => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_poll_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return pollListRes = res.data
    } catch (error) {
        return pollListRes = error.response.data
    }
})

const pollListSlice = createSlice({
    name: 'pollList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(pollListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('pollList', state.data)
            }
        });
        builder.addCase(pollListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default pollListSlice.reducer; 